'use strict';

import EmptyRouterView from '../../../app/views/EmptyRouterView.vue';

export const profileEventRoutes = [
  {
    path: 'events',
    component: EmptyRouterView,
    children: [
      {
        path: '',
        name: 'profile.event',
        redirect: { name: 'profile.event.result.list' },
        // props: true,
        // component: () => import('../views/ManageEventListView.vue'),
      },
      {
        path: 'organized',
        name: 'profile.event.organized.list',
        props: true,
        component: () => import('../views/OrganizedListView.vue'),
      },
      {
        path: 'results',
        name: 'profile.event.result.list',
        props: true,
        component: () => import('../views/ResultListView.vue'),
      },
    ],
  },
];
